'use strict';
import request from '@/utils/request'
class UsersService{
    static login(data){
        return request({
            url:'/users/loginuser',
            method:'post',
            data
        })
    }
    static getdatauser(query){
        return request({
            url:'/users/getuser',
            method:'get',
            params:query
        })
    }
    static create(data){
        return request({
            url:'/users/create',
            method:'post',
            data
        })
    }
    static edit(query,data){
        return request({
            url:'/users/edituser',
            method:'put',
            data,
            params:query
        })
    }
    static searchusers(query){
        return request({
            url:'/users/searchusers',
            method:'get',
            params:query
        })
    }
    static getdatauserprofile(query){
        return request({
            url:'/users/getdatauserprofile',
            method:'get',
            params:query
        })
    }
    static visibleprofileuser(query){
        return request({
            url:'/users/visibleprofileuser',
            method:'get',
            params:query
        })
    }
    static userisfollowing(data){
        return request({
            url:'/users/userisfollowing',
            method:'post',
            data
        })
    }
    static getcountfollowersforusers(data){
        return request({
            url:'/users/getcountfollowersforusers',
            method:'post',
            data
        })
    }
    static stopfollowingthisuser(data){
        return request({
            url:'/users/stopfollowingthisuser',
            method:'post',
            data
        })
    }
    static getfollowers(data){
        return request({
            url:'/users/getfollowers',
            method:'post',
            data
        })
    }
    static uploadimagecover(data){
        return request({
            url:'/users/uploadimagecover',
            method:'put',
            data
        })
    }
    static getuseractive(){
        return request({
            url:'/users/getuseractive',
            method:'get',
        })
    }
    static getuserchoosedservice(query){
        return request({
            url:'/users/session',
            method:'get',
            params:query
        })
    }

}

export default UsersService
